import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(({ palette, spacing }) => ({
  container: {
    backgroundColor: '#FFFFFF',
    paddingBottom: spacing(2)
  },
  paperSuccess: {
    textAlign: 'center',
    padding: spacing(2),
    color: palette.success.main,
    border: '1px solid #E4E7EA',
    borderBottom: `5px solid ${palette.success.main}`,
    borderRadius: 5
  },
  paperError: {
    textAlign: 'center',
    padding: spacing(2),
    color: palette.error.main,
    border: '1px solid #E4E7EA',
    borderBottom: `5px solid ${palette.error.main}`,
    borderRadius: 5
  },
  paperPrimary: {
    textAlign: 'center',
    padding: spacing(2),
    color: palette.primary.main,
    border: '1px solid #E4E7EA',
    borderBottom: `5px solid #757575`,
    borderRadius: 5
  },
  success: {
    color: palette.success.main
  },
  error: {
    color: palette.error.main
  },
  title: {
    fontWeight: 'bold',
    marginRight: spacing(1)
  },
  container: {
    marginTop: spacing(2)
  },
  itemContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: spacing(1)
  },
  marginTop: {
    marginTop: 10
  }
}));